import ShimmerConsultationTypeCard from '../consultationTypeCard/shimmer';

const SHIMER_DATA = [...Array(3).keys()];

const ShimmerConsultationTypes = () => {
  return (
    <div className="flex flex-col gap-y-4">
      {SHIMER_DATA?.map((item) => (
        <ShimmerConsultationTypeCard key={`shimmer-card-${item}`} />
      ))}
    </div>
  );
};

export default ShimmerConsultationTypes;
